import produce from 'immer'
import { createAsyncAction } from 'typesafe-actions'

import { format, DateFormat } from 'packages/utils/dateHelpers'
import {
  RequestConfig,
  RequestOptions,
} from 'packages/utils/store/jsonapi.types'

import { UserApiFieldsWithoutPII } from '../../users'
import { coverageService } from '../coverage.service'
import {
  CoverageActionTypes,
  CoverageApiFields,
  NormalizedCoverageApiResponse,
} from '../coverage.types'

export const fetchCoverageByDateRangeAction = createAsyncAction(
  CoverageActionTypes.FETCH_COVERAGE,
  CoverageActionTypes.FETCH_COVERAGE_SUCCESS,
  CoverageActionTypes.FETCH_COVERAGE_FAILURE,
)<
  RequestConfig<NormalizedCoverageApiResponse>,
  NormalizedCoverageApiResponse,
  Error
>()

export const getParams = (
  dateRange: [string, string],
  userId?: string,
): RequestOptions => ({
  fields: {
    coverage: CoverageApiFields,
    user: UserApiFieldsWithoutPII,
  },
  filter: produce({}, (draft: Record<string, unknown>) => {
    draft.date_range = dateRange.map(date =>
      format(date, DateFormat.ApiUtcShort),
    )

    if (userId) {
      draft.user = userId
    }

    return draft
  }),
  include: ['cross_coverage', 'user'],
  page: { size: 500 },
})

export const fetchCoverageByDateRange =
  (dateRange: [string, string], userId?: string) => async dispatch => {
    try {
      const params = getParams(dateRange, userId)
      const request = coverageService.fetchCoverage.bind(null, params)
      const result = await dispatch(
        fetchCoverageByDateRangeAction.request({ request }),
      )
      dispatch(fetchCoverageByDateRangeAction.success(result))
      return result.normalized
    } catch (error) {
      dispatch(fetchCoverageByDateRangeAction.failure(error))
      throw error
    }
  }
